<div class="logged-user-menu" *ngIf="menuVisible$ | async"
     (click)="$event.stopImmediatePropagation();">
  <div class="menu-link"
       (click)="menuOverlay.toggle($event)"
  >
    <span class="name" *ngIf="customerVisible$ | async">{{ customerName$ | async }}</span>
    <span class="name" *ngIf="contactVisible$ | async">{{ contactName$ | async }}</span>
    <i class="fa fa-chevron-down"></i>
  </div>

  <div class="trustee-logo">
    <llc-trustee-logo [trusteeKey]="(contextTrustee$ | async)?.configKey"
                      [showFallbackLabel]="true"
    ></llc-trustee-logo>
  </div>
  <p-overlayPanel #menuOverlay
                  [dismissable]="true"
  >
    <div class="overlay-menu">
      <div class="logger-user">
        {{ contactName$ | async }}
      </div>
      <a *ngIf="(customerVisible$ | async) && (hasMoreCustomer$ | async)"
         class="customer-change-link" i18n
         (click)="onChangeCustomerClick(); menuOverlay.hide();">
        Changer d'entité
      </a>
      <div class="separator"></div>
      <a class="logout"
         (click)="onLogoutClick(); menuOverlay.hide();"
         i18n>
        Se déconnecter
      </a>
    </div>
  </p-overlayPanel>
</div>
